import { useMemo } from "react";
import { Color } from "three";
export const useSRGBColors = (color) => {
    const threeColor = useMemo(() => {
        if (!color)
            return color;
        const sRgbCol = typeof color !== 'string' ?
            `rgb(${color[0]}, ${color[1]}, ${color[2]})` :
            color;
        return new Color(sRgbCol);
    }, [color]);
    return threeColor;
};
